import { apiClient } from './client';

export interface LeadDetailOptions {
  include?: Array<'chats' | 'pipelines' | 'projects'>;
  chats_limit?: number;
}

export interface LeadDetailResponse {
  output: {
    prospect: any;
    prospect_companies?: any[];
    chats?: { items: any[]; total_results?: number };
    pipelines?: any[];
    project_prospects?: any[];
  };
  error: boolean;
  http_response_code: number;
  error_messages: string[];
}

export const leadApi = {
  async getLeadDetail(prospectId: string, options: LeadDetailOptions = {}): Promise<LeadDetailResponse> {
    const params: any = {};
    if (options.include && options.include.length > 0) params.include = options.include;
    if (options.chats_limit !== undefined) params.chats_limit = options.chats_limit;
    const res = await apiClient.get(`/leads/${prospectId}/`, { 
      params,
      paramsSerializer: {
        serialize: (p: any) => {
          const usp = new URLSearchParams();
          Object.entries(p).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            if (Array.isArray(value)) {
              value.forEach((v) => usp.append(key, String(v)));
            } else {
              usp.append(key, String(value));
            }
          });
          return usp.toString();
        },
      },
    });
    return res.data as LeadDetailResponse;
  },

  async resyncLead(prospectId: string): Promise<any> {
    const res = await apiClient.post(`/leads/${prospectId}/sync/`);
    return res.data;
  },
};




